import { Card, Col, DatePicker, Form, Input, Row } from "antd";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import ActionsLog from "../../../../../components/common/ActionsLog";
import AttachmentsUpload from "../../../../../components/common/AttachmentsUpload";
import FormAction from "../../../../../components/common/FormAction";
import Notes from "../../../../../components/common/Notes";
import PageHeading from "../../../../../components/common/PageHeading";
import { receiptsTableData } from "../../../../../data/accounting";

import { FaRegEdit, FaPrint, FaDownload } from "react-icons/fa";
import { MdOutlineMailOutline } from "react-icons/md";

import "./ReceiptDetails.css";
import RightBarMethod from "../../../../../components/common/RightBar/RightBarMethod";
import RightBar from "../../../../../components/common/RightBar";

const ReceiptDetailsRightBar = [
  RightBarMethod("Tasks", "t1", <i className="fa-solid fa-star"></i>, [
    RightBarMethod(
      "Tenant Receipt",
      "1",
      "",
      "",
      "/accounting/receivables_payments/reciepts/tenant_receipts/new"
    ),
    RightBarMethod(
      "Homeowner Receipt",
      "2",
      "",
      "",
      "/accounting/receivables_payments/reciepts//HomeownerReceipt"
    ),
    RightBarMethod(
      "Other Receipt",
      "3",
      "",
      "",
      "/accounting/receivables_payments/reciepts/otherReceipt"
    ),
    RightBarMethod(
      "Subsidy Receipt",
      "4",
      "",
      "",
      "/accounting/receivables_payments/reciepts/subsidyreceipt"
    ),
    RightBarMethod(
      "Application Fee",
      "5",
      "",
      "",
      "/accounting/receivables_payments/reciepts/newapplicationfee"
    ),
    RightBarMethod(
      "Bulk Charges & Credits",
      "8",
      "",
      "",
      "/accounting/receivables_payments/invoices/bulkchargesandcredits"
    ),
    RightBarMethod(
      "Tenant Charge",
      "6",
      "",
      "",
      "/accounting/receivables_payments/invoices/tenantcharge"
    ),
    RightBarMethod(
      "Homeowner Charge",
      "7",
      "",
      "",
      "/accounting/receivables_payments/invoices/homeownercharge"
    ),
    RightBarMethod(
      "Bulk Recurring Charges",
      "9",
      "",
      "",
      "/accounting/receivables_payments/invoices/bulkrecurringcharges"
    ),
    RightBarMethod(
      "Tenant Credit",
      "10",
      "",
      "",
      "/accounting/receivables_payments/invoices/newtenantcredit"
    ),
    RightBarMethod(
      "Homeowner Credit",
      "11",
      "",
      "",
      "/accounting/receivables_payments/invoices/newhomeownercredit"
    ),
    RightBarMethod(
      "Apply Credits",
      "12",
      "",
      "",
      "/accounting/receivables_payments/reciepts/applycredits"
    ),
    RightBarMethod(
      "Common Charge",
      "13",
      "",
      "",
      "/accounting/receivables_payments/invoices/NewCommonCharge"
    ),
    RightBarMethod(
      "Charge Late Fees",
      "14",
      "",
      "",
      "/accounting/receivables_payments/chargelatefees"
    ),
    RightBarMethod(
      "New Bank Deposit",
      "15",
      "",
      "",
      "/accounting/receivables_payments/bank_deposits/NewBankDeposit"
    ),
    RightBarMethod(
      "Lockbox",
      "16",
      "",
      "",
      "/accounting/receivables_payments/lockbox"
    ),
  ]),
  RightBarMethod(
    "REPORTS",
    "t2",
    <i className="fa-solid fa-chart-column"></i>,
    [
      RightBarMethod("Tenant Ledger", "17", "", "", "/"),
      RightBarMethod("Receivables Activity", "18", "", "", "/"),
    ]
  ),
  RightBarMethod(
    " HELP TOPICS",
    "t3",
    <i className="fa-solid fa-circle-question"></i>,
    [RightBarMethod("Tenant Online Payments", "19", "", "", "/")]
  ),
];

function ReceiptDetails() {
  const [checked, setChecked] = useState(false);
  const [receiptDetails, setReceiptDetails] = useState(false);

  const { id } = useParams();

  useEffect(() => {
    const newObject = receiptsTableData.find((item) => {
      return item.id === Number(id);
    });
    setReceiptDetails(newObject);
  }, []);

  const onCancel = () => {
    setChecked(false);
  };

  return (
    <>
      <div className="receipt-details">
        {!checked ? (
          <Row gutter={[8, 0]} justify="end">
            <Col>
              <button
                className="icon-btn-container"
                onClick={() => setChecked(true)}
              >
                <FaRegEdit size={16} />
                <span>Edit</span>
              </button>
            </Col>
            <Col>
              <button className="icon-btn-container">
                <FaPrint size={16} />
                <span>Print</span>
              </button>
            </Col>
            <Col>
              <button className="icon-btn-container">
                <FaDownload size={16} />
                <span>Download</span>
              </button>
            </Col>
            <Col>
              <button className="icon-btn-container">
                <MdOutlineMailOutline size={16} />
                <span>Email</span>
              </button>
            </Col>
          </Row>
        ) : null}
        <PageHeading heading="ACH Receipt" />
        <Form
          colon={false}
          labelCol={{ span: 8 }}
          wrapperCol={{ span: 11 }}
          labelWrap={{ span: 8 }}
        >
          <Row gutter={[0, 24]}>
            <Col span={24}>
              <Card>
                <Form.Item label="Payer">
                  <p>{receiptDetails?.payer}</p>
                </Form.Item>
                <Form.Item label="Total Amount">
                  <p>{receiptDetails?.amount}</p>
                </Form.Item>
                <Form.Item
                  label="Receipt Date"
                  required={checked ? true : false}
                >
                  {checked ? (
                    <DatePicker style={{ width: "100%" }} />
                  ) : (
                    <p>{receiptDetails?.date}</p>
                  )}
                </Form.Item>
                <Form.Item label="Property">
                  <p>{receiptDetails?.propertyUnit}</p>
                </Form.Item>
                <Form.Item label="Unit">
                  <p>{receiptDetails?.unit}</p>
                </Form.Item>
                <Form.Item label="Reference">
                  <p>{receiptDetails?.reference}</p>
                </Form.Item>
                <Form.Item label="Remarks">
                  {checked ? <Input /> : <p>{receiptDetails?.remarks}</p>}
                </Form.Item>
                <Form.Item label="Cash Account">
                  <p>{receiptDetails?.cashAccount}</p>
                </Form.Item>
                <Form.Item label="Bank Deposit">
                  <p>{receiptDetails?.bankDeposit}</p>
                </Form.Item>
              </Card>
            </Col>
            <Col span={24} className="table-container">
              <Card>
                <Row className="header-row">
                  <Col span={10}>
                    <span>GL Account</span>
                  </Col>
                  <Col span={10}>
                    <span>Description</span>
                  </Col>
                  <Col span={4}>
                    <span>Amount</span>
                  </Col>
                </Row>
                {receiptDetails?.account
                  ? receiptDetails.account.map((item, index) => {
                      return (
                        <Row key={index} className="data-row">
                          <Col span={10}>
                            <span>{item.gLAccount}</span>
                          </Col>
                          <Col span={10}>
                            {checked ? (
                              <Form.Item>
                                <Input />
                              </Form.Item>
                            ) : (
                              <span>{item.description}</span>
                            )}
                          </Col>
                          <Col span={4}>
                            <span>{item.amount}</span>
                          </Col>
                        </Row>
                      );
                    })
                  : null}
                {!checked ? (
                  <Row className="receipt-total" gutter={[24, 0]}>
                    <Col>
                      <strong>Total:</strong>
                    </Col>
                    <Col>
                      <strong>108:00</strong>
                    </Col>
                  </Row>
                ) : null}
              </Card>
            </Col>
            {checked ? (
              <Col span={24}>
                <FormAction cancel={onCancel} />
              </Col>
            ) : null}
            <Col span={24}>
              <ActionsLog />
            </Col>
            <Col span={24}>
              {/* <Notes /> */}
            </Col>
            <Col span={24}>
              {/* <AttachmentsUpload /> */}
            </Col>
          </Row>
        </Form>
      </div>
      <div className="RightSidebar">
        <RightBar RightBarData={ReceiptDetailsRightBar} />
      </div>
    </>
  );
}

export default ReceiptDetails;
